import React, { Component } from "react";
import ToastIcon from "./img/toast-icon.svg";
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

import "./Toast.scss";

class Toast extends Component {
  genIconContainer = () => {
    let color = colors.charcoal1;

    switch (this.props.type) {
      case "WARNING":
        color = colors.red2;
        break;

      case "HINT":
        color = colors.yellow1;
        break;

      case "SUCCESS":
        color = colors.green1;
        break;

      default:
        break;
    }

    return (
      <div className="toast-img-container" style={{ backgroundColor: color }}>
        <img className="toast-icon" alt="Notification icon." src={ToastIcon} />
      </div>
    );
  };

  componentDidMount() {
    this.toast.focus();
  }

  render() {
    return (
      <div className="toast-container">
        {this.genIconContainer()}
        <div
          role="button"
          tabIndex={0}
          className="toast-text-container"
          data-autofocus
          ref={(toast) => {
            this.toast = toast;
          }}
          onClick={this.props.closeToast}
          onKeyDown={this.props.closeToast}
        >
          <p className="toast-text-heading">{this.props.title}</p>
          <p className="toast-text-message">{this.props.msg}</p>
        </div>
      </div>
    );
  }
}

export default Toast;
